(() => {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8291"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8291"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("agP5P", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("4fcA8")).then(()=>parcelRequire('c2C9D'));

});
parcelRegister("dNLwc", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("7lV8K", function(module, exports) {
"use strict";
var $55a6d16921f8ab25$var$cachedBundles = {};
var $55a6d16921f8ab25$var$cachedPreloads = {};
var $55a6d16921f8ab25$var$cachedPrefetches = {};
function $55a6d16921f8ab25$var$getCache(type) {
    switch(type){
        case 'preload':
            return $55a6d16921f8ab25$var$cachedPreloads;
        case 'prefetch':
            return $55a6d16921f8ab25$var$cachedPrefetches;
        default:
            return $55a6d16921f8ab25$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $55a6d16921f8ab25$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("gPE8G", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("lpjhe")).then(()=>parcelRequire('74dhL'));

});

parcelRegister("3z9vz", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("8TD9g"))($parcel$resolve("gbQ6J")),
    (parcelRequire("dNLwc"))($parcel$resolve("hfiXc"))
]).then(()=>parcelRequire('lJVLV'));

});
parcelRegister("8TD9g", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});


parcelRegister("hjs2Y", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("fmumS")).then(()=>parcelRequire('izYUv'));

});

parcelRegister("5aW2j", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("eYRAf")).then(()=>parcelRequire('yYI5I'));

});

parcelRegister("6RZeE", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("imk6V")).then(()=>parcelRequire('lMtJd'));

});

parcelRegister("c60dm", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("3563r")).then(()=>parcelRequire('j9KRq'));

});

parcelRegister("2BQvH", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("5TJ3Y")).then(()=>parcelRequire('hqiRa'));

});

parcelRegister("bdlUV", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("3qhPQ")).then(()=>parcelRequire('fcLO3'));

});

parcelRegister("cfVbp", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("8TD9g"))($parcel$resolve("eITKv")),
    (parcelRequire("dNLwc"))($parcel$resolve("5NuFy"))
]).then(()=>parcelRequire('ex6xR'));

});

var $2be77c1a8fd312f1$exports = {};
$parcel$extendImportMap({
    "4fcA8": "quickQuote.c43d844b.js",
    "lpjhe": "productListings.d05cbf8e.js",
    "hfiXc": "locationSearchMap.650b1f78.js",
    "gbQ6J": "locationSearchMap.55aa9d11.css",
    "fmumS": "forms.8ce22a6f.js",
    "eYRAf": "tabs.9738c031.js",
    "imk6V": "modals.03bbc1a2.js",
    "3563r": "inPageLinks.d063793f.js",
    "5TJ3Y": "loadingSpinners.83c75eb8.js",
    "3qhPQ": "faqPredictiveSearch.33ddc4ea.js",
    "5NuFy": "webChat.f648a418.js",
    "eITKv": "webChat.524afd8b.css"
});

const $6097d461168bf6e5$var$mobileNav = document.getElementById('mobile-menu');
if ($6097d461168bf6e5$var$mobileNav !== null) {
    const mobileNavBtn = document.getElementById('menu-btn');
    const mobileMediaQuery = window.matchMedia('(max-width: 768px)');
    const headerLogo = document.getElementById('header-logo-mobile');
    const corpLogo = document.getElementById('corporate-logo');
    const searchForm = document.getElementById('search-form');
    const search = document.getElementById('search');
    const ctaButtons = document.getElementById("campaign-menu");
    const setMenuOpen = (isOpen = true)=>{
        mobileNavBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        $6097d461168bf6e5$var$mobileNav.hidden = !isOpen;
        headerLogo.hidden = !$6097d461168bf6e5$var$mobileNav.hidden && mobileMediaQuery.matches;
        if (ctaButtons) ctaButtons.hidden = !$6097d461168bf6e5$var$mobileNav.hidden && mobileMediaQuery.matches;
        if (corpLogo) corpLogo.hidden = !$6097d461168bf6e5$var$mobileNav.hidden && mobileMediaQuery.matches;
        searchForm.hidden = $6097d461168bf6e5$var$mobileNav.hidden && mobileMediaQuery.matches;
        search.placeholder = mobileMediaQuery.matches ? 'Search Westfund' : 'Search';
    };
    mobileNavBtn.addEventListener('click', ()=>{
        setMenuOpen($6097d461168bf6e5$var$mobileNav.hidden);
        document.body.classList.toggle('overflow-hidden');
        document.getElementById("corp-header-logo")?.classList.toggle('hidden');
    });
    setMenuOpen(!mobileMediaQuery.matches);
    try {
        mobileMediaQuery.addEventListener('change', (e)=>setMenuOpen(!e.matches));
    } catch (e) {
        // Safari doesn't understand mobileMediaQuery.addEventListener
        mobileMediaQuery.addListener((e)=>setMenuOpen(!e.matches));
    }
}


const $e61a5ed6516e9695$var$joinForms = document.querySelectorAll("form[data-join-step]");
const $e61a5ed6516e9695$var$getVisitorType = ()=>{
    return window.Westfund.IsOverseas ? "Overseas" : "Domestic";
};
$e61a5ed6516e9695$var$joinForms.forEach((joinForm)=>{
    const getSelectOptionText = (name)=>{
        const formData = new FormData(joinForm);
        const selectValue = formData.get(name);
        const selectElement = joinForm.querySelector(`[name="${name}"]`);
        const selectedOption = selectElement.querySelector(`option[value="${selectValue}"]`);
        const isHidden = selectElement.closest('.hidden');
        return isHidden ? '' : (selectedOption?.innerHTML || '').trim();
    };
    if (joinForm !== null) {
        const step = joinForm.getAttribute("data-join-step");
        // Analytics spreadsheet row no. 2
        if (step === "residency") joinForm.addEventListener("submit", ()=>{
            const selectedResidencyElem = document.querySelector('input[name="Residency"]:checked');
            dataLayer.push({
                event: "quoteStep1",
                step_number: 'Step 1',
                residencyStatus: selectedResidencyElem.dataset.analyticsValue
            });
        });
        // Analytics spreadsheet row no. 3
        if (step === "what-cover") joinForm.addEventListener("submit", ()=>{
            const formData = new FormData(joinForm);
            const coverType = formData.get("Cover") || "";
            dataLayer.push({
                event: "quoteStep2",
                coverSelection: coverType === 'hospital-extras' ? "Hospital & Extras" : "Ambulance Cover"
            });
        });
        if (step == "overseas-purpose") joinForm.addEventListener("submit", ()=>{
            dataLayer.push({
                event: "quoteStep1.1",
                step_number: "Step 1.1",
                visitorType: $e61a5ed6516e9695$var$getVisitorType()
            });
        });
        if (step == "membership-status") joinForm.addEventListener("submit", ()=>{
            if (window.Westfund.IsOverseas) dataLayer.push({
                event: "quoteStep2",
                step_number: "Step 2",
                visitorType: $e61a5ed6516e9695$var$getVisitorType()
            });
            else dataLayer.push({
                event: "quoteStep1.1",
                visitorType: $e61a5ed6516e9695$var$getVisitorType()
            });
        });
        // Analytics spreadsheet row no. 4 & no. 5
        if (step === "details" || step === "edit") {
            function calculateAge(dob) {
                var diff_ms = Date.now() - dob.getTime();
                var age_dt = new Date(diff_ms);
                return String(Math.abs(age_dt.getUTCFullYear() - 1970));
            }
            joinForm.addEventListener("submit", ()=>{
                const formData = new FormData(joinForm);
                const dayElement = joinForm.querySelector('#MainDOBDay');
                const monthElement = joinForm.querySelector('#MainDOBMonth');
                const yearElement = joinForm.querySelector('#MainDOBYear');
                const dob = new Date(parseInt(yearElement.value), parseInt(monthElement.value) - 1, parseInt(dayElement.value));
                const mainAge = calculateAge(dob);
                let partnerAge = '';
                const coverType = formData.get("CoverType");
                if (coverType === "family" || coverType === "couple") {
                    const partnerDayElement = joinForm.querySelector('#PartnerDOBDay');
                    const partnerMonthElement = joinForm.querySelector('#PartnerDOBMonth');
                    const partnerYearElement = joinForm.querySelector('#PartnerDOBYear');
                    const partnerDob = new Date(parseInt(partnerYearElement.value), parseInt(partnerMonthElement.value) - 1, parseInt(partnerDayElement.value));
                    partnerAge = calculateAge(partnerDob);
                }
                const detailsData = {
                    event: step === "details" ? "quoteStep3" : "coverDetailsUpdated",
                    coverType: formData.get("CoverType"),
                    state: formData.get("State"),
                    mainAge: mainAge,
                    partnerAge: partnerAge,
                    govtRebateTier: formData.get("GovtRebateTier"),
                    pregnancyOnly: formData.get("PregnancyOnly") === "true" ? "true" : "false",
                    visitorType: $e61a5ed6516e9695$var$getVisitorType(),
                    coverSelection: coverType === 'hospital-extras' ? "Hospital & Extras" : "Ambulance Cover"
                };
                if (window.Westfund.IsOverseas) {
                    const countryDropdown = joinForm.querySelector("[name='CountryCode']");
                    const selectedOption = countryDropdown.options[countryDropdown.selectedIndex];
                    detailsData.originCountry = selectedOption.innerText;
                }
                if (step === "details") detailsData.step_number = "Step 3";
                dataLayer.push(detailsData);
            });
        }
        switch(step){
            case "tell-us-about-you":
                joinForm.addEventListener("submit", ()=>{
                    const formData = new FormData(joinForm);
                    const aboutYouData = {
                        'event': 'aboutYouStep1',
                        'referralChannel': getSelectOptionText('HeardAbout'),
                        'visitorType': $e61a5ed6516e9695$var$getVisitorType(),
                        'flow_section': 'About You',
                        'step_number': 'Step 1',
                        coverType: formData.get("CoverType"),
                        state: formData.get("State"),
                        coverSelection: coverType === 'hospital-extras' ? "Hospital & Extras" : "Ambulance Cover"
                    };
                    if (window.Westfund.IsOverseas) {
                        const countryDropdown = joinForm.querySelector("[name='CountryCode']");
                        const selectedOption = countryDropdown.options[countryDropdown.selectedIndex];
                        aboutYouData.originCountry = selectedOption.innerText;
                    }
                    if (hospitalSelectors.length > 0) hospitalSelectors.forEach((hospitalSelector)=>{
                        const overseasExtrasCoverLevel = hospitalSelector.getAttribute("data-extras-cover-level");
                        aboutYouData.extrasCoverLevel = overseasExtrasCoverLevel;
                        aboutYouData.hospitalCoverLevel = hospitalSelector.getAttribute("data-hospital-cover-level");
                    });
                    dataLayer.push(aboutYouData);
                });
                break;
            case "tell-us-about-you-contact":
                joinForm.addEventListener("submit", ()=>{
                    const formData = new FormData(joinForm);
                    const coverType = formData.get("Cover") || "";
                    dataLayer.push({
                        'event': 'aboutYouStep2',
                        'visitorType': $e61a5ed6516e9695$var$getVisitorType(),
                        'flow_section': 'About You',
                        'step_number': 'Step 2',
                        coverType: formData.get("CoverType"),
                        state: formData.get("State"),
                        coverSelection: coverType === 'hospital-extras' ? "Hospital & Extras" : "Ambulance Cover"
                    });
                });
                break;
            case "tell-us-about-you-dependents":
                joinForm.addEventListener("submit", ()=>{
                    dataLayer.push({
                        'event': 'aboutYouStep3',
                        'flow_section': 'About You',
                        'step_number': 'Step 3',
                        'visitorType': $e61a5ed6516e9695$var$getVisitorType()
                    });
                });
                break;
            case "your-cover-rebate":
                joinForm.addEventListener("submit", ()=>{
                    const formData = new FormData(joinForm);
                    const coverType = formData.get("Cover") || "";
                    dataLayer.push({
                        'event': 'yourCoverStep1',
                        'coverType': formData.get("CoverType"),
                        'coverSelection': coverType === 'hospital-extras' ? "Hospital & Extras" : "Ambulance Cover"
                    });
                });
                break;
            case "your-cover-transfer":
                if (window.Westfund.IsOverseas) joinForm.addEventListener("submit", ()=>{
                    dataLayer.push({
                        'event': 'aboutYouStep4',
                        'flow_section': 'About You',
                        'step_number': 'Step 4',
                        'visitorType': $e61a5ed6516e9695$var$getVisitorType()
                    });
                });
                else joinForm.addEventListener("submit", ()=>{
                    const formData = new FormData(joinForm);
                    const aboutYouData = {
                        'event': 'yourCoverStep2',
                        'flow_section': 'Your Cover',
                        'step_number': 'Step 2',
                        'visitorType': $e61a5ed6516e9695$var$getVisitorType(),
                        'currentFund': getSelectOptionText('PreviousFundId'),
                        'whyWestfund': getSelectOptionText('JoinReasonId'),
                        'referralChannel': getSelectOptionText('HeardAbout'),
                        coverType: formData.get("CoverType"),
                        state: formData.get("State"),
                        coverSelection: coverType === 'hospital-extras' ? "Hospital & Extras" : "Ambulance Cover"
                    };
                    if (hospitalSelectors.length > 0) hospitalSelectors.forEach((hospitalSelector)=>{
                        const overseasExtrasCoverLevel = hospitalSelector.getAttribute("data-extras-cover-level");
                        aboutYouData.extrasCoverLevel = overseasExtrasCoverLevel;
                        aboutYouData.hospitalCoverLevel = hospitalSelector.getAttribute("data-hospital-cover-level");
                    });
                    dataLayer.push(aboutYouData);
                });
                break;
            case "your-cover-lhc":
                joinForm.addEventListener("submit", ()=>{
                    const formData = new FormData(joinForm);
                    const aboutYouData = {
                        'event': 'yourCoverStep3',
                        'flow_section': 'Your Cover',
                        'step_number': 'Step 3',
                        'visitorType': $e61a5ed6516e9695$var$getVisitorType(),
                        'currentFund': getSelectOptionText('PreviousFundId'),
                        'whyWestfund': getSelectOptionText('JoinReasonId'),
                        'referralChannel': getSelectOptionText('HeardAbout'),
                        coverType: formData.get("CoverType"),
                        state: formData.get("State"),
                        coverSelection: coverType === 'hospital-extras' ? "Hospital & Extras" : "Ambulance Cover"
                    };
                    dataLayer.push(aboutYouData);
                });
                break;
            case "your-cover-concession":
                joinForm.addEventListener("submit", ()=>{
                    const formData = new FormData(joinForm);
                    const aboutYouData = {
                        'event': 'yourCoverStep4',
                        'flow_section': 'Your Cover',
                        'step_number': 'Step 4',
                        'visitorType': $e61a5ed6516e9695$var$getVisitorType(),
                        'currentFund': getSelectOptionText('PreviousFundId'),
                        'whyWestfund': getSelectOptionText('JoinReasonId'),
                        'referralChannel': getSelectOptionText('HeardAbout'),
                        coverType: formData.get("CoverType"),
                        state: formData.get("State"),
                        coverSelection: coverType === 'hospital-extras' ? "Hospital & Extras" : "Ambulance Cover"
                    };
                    dataLayer.push(aboutYouData);
                });
                break;
            case "pay-promo":
                joinForm.addEventListener("submit", ()=>{
                    const formData = new FormData(joinForm);
                    const promoCode = formData.get("PromotionCodeId") || "";
                    dataLayer.push({
                        'event': 'paySubmitStep1',
                        'promoCode': promoCode,
                        'visitorType': $e61a5ed6516e9695$var$getVisitorType(),
                        'flow_section': 'Pay & Submit',
                        'step_number': 'Step 1',
                        'currentFund': getSelectOptionText('PreviousFundId'),
                        'whyWestfund': getSelectOptionText('JoinReasonId'),
                        'referralChannel': getSelectOptionText('HeardAbout'),
                        coverType: formData.get("CoverType"),
                        state: formData.get("State"),
                        coverSelection: coverType === 'hospital-extras' ? "Hospital & Extras" : "Ambulance Cover"
                    });
                });
                break;
            case "pay-start":
                joinForm.addEventListener("submit", ()=>{
                    dataLayer.push({
                        'event': 'paySubmitStep2',
                        'visitorType': $e61a5ed6516e9695$var$getVisitorType(),
                        'flow_section': 'Pay & Submit',
                        'step_number': 'Step 2',
                        'currentFund': getSelectOptionText('PreviousFundId'),
                        'whyWestfund': getSelectOptionText('JoinReasonId'),
                        'referralChannel': getSelectOptionText('HeardAbout'),
                        coverType: formData.get("CoverType"),
                        state: formData.get("State"),
                        coverSelection: coverType === 'hospital-extras' ? "Hospital & Extras" : "Ambulance Cover"
                    });
                });
                break;
            case "pay-terms":
                joinForm.addEventListener("submit", ()=>{
                    dataLayer.push({
                        'event': 'paySubmitStep3',
                        'visitorType': $e61a5ed6516e9695$var$getVisitorType(),
                        'flow_section': 'Pay & Submit',
                        'step_number': 'Step 3',
                        'currentFund': getSelectOptionText('PreviousFundId'),
                        'whyWestfund': getSelectOptionText('JoinReasonId'),
                        'referralChannel': getSelectOptionText('HeardAbout'),
                        coverType: formData.get("CoverType"),
                        state: formData.get("State"),
                        coverSelection: coverType === 'hospital-extras' ? "Hospital & Extras" : "Ambulance Cover"
                    });
                });
                break;
            case "pay-details":
                break;
            default:
                const memberIdMatches = window.location.href.match(/MemberId=([^&]*)/i);
                const isCorporate = window.location.href.match(/IsCorporate=1/i) !== null;
                if (memberIdMatches) dataLayer.push({
                    'membershipNumber': memberIdMatches[1],
                    'memberType': isCorporate ? 'corporate' : 'consumer'
                });
                break;
        }
    }
    const hospitalSelectors = [
        ...document.querySelectorAll("button[data-select-hospital]")
    ];
    if (hospitalSelectors.length > 0) hospitalSelectors.forEach((hospitalSelector)=>{
        // Analytics spreadsheet row no. 6
        const formData = new FormData(joinForm);
        const coverType = formData.get("Cover") || "";
        hospitalSelector.addEventListener("click", ()=>{
            if (window.Westfund.IsOverseas) {
                const overseasHospitalCoverLevel = hospitalSelector.getAttribute("data-hospital-cover-level");
                const overseasExtrasCoverLevel = hospitalSelector.getAttribute("data-extras-cover-level");
                dataLayer.push({
                    event: "extrasCoverSelection",
                    hospitalCoverLevel: overseasHospitalCoverLevel,
                    extrasCoverLevel: overseasExtrasCoverLevel,
                    visitorType: $e61a5ed6516e9695$var$getVisitorType()
                });
            } else dataLayer.push({
                event: "hospitalCoverSelection",
                hospitalCover: hospitalSelector.getAttribute("data-hospital-cover"),
                hospitalCoverLevel: hospitalSelector.getAttribute("data-hospital-cover-level"),
                excessChosen: "$" + hospitalSelector.getAttribute("data-excess-chosen"),
                visitorType: $e61a5ed6516e9695$var$getVisitorType(),
                coverType: formData.get("CoverType"),
                state: formData.get("State"),
                coverSelection: coverType === 'hospital-extras' ? "Hospital & Extras" : "Ambulance Cover"
            });
            const joinBtn = document.querySelector("button[data-join]");
            if (joinBtn !== null) {
                const overseasExtrasCoverLevel = hospitalSelector.getAttribute("data-extras-cover-level");
                const extrasSelectors = [
                    ...document.querySelectorAll("button[data-select-extras]")
                ];
                var test = extrasSelectors;
                if (extrasSelectors.length > 0) extrasSelectors.forEach((extrasSelector)=>{
                    // Analytics spreadsheet row no. 8
                    joinBtn.addEventListener("click", ()=>{
                        dataLayer.push({
                            event: "joinStep1",
                            coverName: joinBtn.getAttribute("data-cover-name"),
                            premium: "$" + joinBtn.getAttribute("data-premium"),
                            paymentFrequency: joinBtn.getAttribute("data-frequency"),
                            visitorType: $e61a5ed6516e9695$var$getVisitorType(),
                            coverType: formData.get("CoverType"),
                            state: formData.get("State"),
                            hospitalCover: hospitalSelector.getAttribute("data-hospital-cover"),
                            hospitalCoverLevel: hospitalSelector.getAttribute("data-hospital-cover-level"),
                            excessChosen: "$" + hospitalSelector.getAttribute("data-excess-chosen"),
                            extrasCoverLevel: overseasExtrasCoverLevel,
                            extrasCover: extrasSelector.getAttribute("data-extras-cover"),
                            coverSelection: coverType === 'hospital-extras' ? "Hospital & Extras" : "Ambulance Cover"
                        });
                    });
                    const emailQuoteForm = document.querySelector("#save-quote-modal form");
                    if (emailQuoteForm !== null) // Analytics spreadsheet row no. 9
                    emailQuoteForm.addEventListener("submit", ()=>{
                        dataLayer.push({
                            event: "quoteEmailed",
                            coverName: joinBtn.getAttribute("data-cover-name"),
                            premium: "$" + joinBtn.getAttribute("data-premium"),
                            paymentFrequency: joinBtn.getAttribute("data-frequency"),
                            visitorType: $e61a5ed6516e9695$var$getVisitorType(),
                            coverType: formData.get("CoverType"),
                            state: formData.get("State"),
                            hospitalCover: hospitalSelector.getAttribute("data-hospital-cover"),
                            hospitalCoverLevel: hospitalSelector.getAttribute("data-hospital-cover-level"),
                            excessChosen: "$" + hospitalSelector.getAttribute("data-excess-chosen"),
                            extrasCoverLevel: overseasExtrasCoverLevel,
                            extrasCover: extrasSelector.getAttribute("data-extras-cover"),
                            coverSelection: coverType === 'hospital-extras' ? "Hospital & Extras" : "Ambulance Cover"
                        });
                    });
                });
            }
        });
    });
    const extrasSelectors = [
        ...document.querySelectorAll("button[data-select-extras]")
    ];
    const formData = new FormData(joinForm);
    const coverType = formData.get("Cover") || "";
    if (extrasSelectors.length > 0) extrasSelectors.forEach((extrasSelector)=>{
        // Analytics spreadsheet row no. 7
        extrasSelector.addEventListener("click", ()=>{
            dataLayer.push({
                event: "extrasCoverSelection",
                extrasCover: extrasSelector.getAttribute("data-extras-cover"),
                extrasCoverLevel: extrasSelector.getAttribute("data-extras-cover-level"),
                visitorType: $e61a5ed6516e9695$var$getVisitorType(),
                coverType: formData.get("CoverType"),
                state: formData.get("State"),
                coverSelection: coverType === 'hospital-extras' ? "Hospital & Extras" : "Ambulance Cover"
            });
        });
    });
});
const $e61a5ed6516e9695$var$formulateWrappers = [
    ...document.querySelectorAll(".formulate-wrapper")
];
if ($e61a5ed6516e9695$var$formulateWrappers.length > 0) $e61a5ed6516e9695$var$formulateWrappers.forEach((wrapper)=>{
    // Analytics spreadsheet row no. 10
    wrapper.addEventListener("formulate form: submit: success", (e)=>{
        const form = e.target;
        const appointmentTypeSelect = form.querySelector('select[aria-label="Appointment Type"]');
        if (appointmentTypeSelect !== null) {
            const appointmentType = appointmentTypeSelect.value;
            dataLayer.push({
                event: "appointmentRequested",
                appointmentType: appointmentType
            });
        }
    });
});
const $e61a5ed6516e9695$var$socialShare = [
    ...document.querySelectorAll(".social-share a")
];
if ($e61a5ed6516e9695$var$socialShare.length > 0) $e61a5ed6516e9695$var$socialShare.forEach((link)=>{
    link.addEventListener("click", function() {
        const socialMedia = link.getAttribute("aria-label");
        const pageTitle = document.querySelector("meta[name='title']")?.getAttribute("content");
        dataLayer.push({
            event: "socialShare",
            social: socialMedia,
            pageTitle: pageTitle
        });
    });
});


// Define a structural interface for the captured query parameters
class $e60b1f04d2696076$export$e6ffea1e6f17a238 {
    constructor(){
        // Define cookie names as constants
        this.DOMESTIC_COOKIE = 'WFDomesticAffiliate';
        this.OVHC_COOKIE = 'WFOVHCAffiliate';
        this.captureDetails();
    }
    /**
     * Parses the current window location search string and extracts relevant parameters.
     */ getAllQueryVars() {
        const query = window.location.search;
        if (!query) return [];
        // Remove the leading '?' if it exists
        const queryString = query.startsWith('?') ? query.slice(1) : query;
        return queryString.split('&').map((param)=>{
            const [key, value] = param.split('=');
            return {
                name: key.toLowerCase(),
                value: value ? decodeURIComponent(value.replace(/\+/g, ' ')) : ''
            };
        });
    }
    /**
     * Captures the specific agent IDs from the URL and saves them to their respective cookies.
     */ captureDetails() {
        const queryVars = this.getAllQueryVars();
        if (queryVars.length === 0) return;
        // Process each target parameter individually using native browser logic
        queryVars.forEach((qv)=>{
            if (qv.value === '') return;
            if (qv.name === 'agentid') this.setCookie(this.DOMESTIC_COOKIE, qv.value, 7);
            else if (qv.name === 'osagentid') this.setCookie(this.OVHC_COOKIE, qv.value, 7);
        });
    }
    /**
     * Native browser utility to write a cookie.
     */ setCookie(name, value, daysToExpire) {
        const date = new Date();
        date.setTime(date.getTime() + daysToExpire * 86400000);
        const expires = `expires=${date.toUTCString()}`;
        // path=/ ensures the cookie is accessible across the entire website
        document.cookie = `${name}=${encodeURIComponent(value)};${expires};path=/;SameSite=Lax`;
    }
    /**
     * Native browser utility to read a cookie value by its name.
     */ getCookie(name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return '';
    }
    /**
     * Manually sets the Domestic Agent ID cookie.
     * @param value The agent ID value to store.
     */ setDomesticAgentId(value) {
        this.setCookie(this.DOMESTIC_COOKIE, value, this.COOKIE_EXPIRY_DAYS);
    }
    /**
     * Manually sets the OVHC Agent ID cookie.
     * @param value The agent ID value to store.
     */ setOvhcAgentId(value) {
        this.setCookie(this.OVHC_COOKIE, value, this.COOKIE_EXPIRY_DAYS);
    }
    /**
     * Retrieves the captured Domestic Agent ID from the cookie.
     */ getCapturedDomesticAgentId() {
        return this.getCookie(this.DOMESTIC_COOKIE);
    }
    /**
     * Retrieves the captured OVHC Agent ID from the cookie.
     */ getCapturedOvhcAgentId() {
        return this.getCookie(this.OVHC_COOKIE);
    }
}
window.WF = window.WF || {};
window.WF.AffiliateCapture = new $e60b1f04d2696076$export$e6ffea1e6f17a238();



if (document.querySelector('.quick-quote-domestic')) (parcelRequire("agP5P")).then((script)=>script.run('.quick-quote-domestic', 'domestic'));

if (document.querySelector('.quick-quote-overseas')) (parcelRequire("agP5P")).then((script)=>script.run('.quick-quote-overseas', 'overseas'));

if (document.getElementById("new-product-table") !== null) (parcelRequire("gPE8G")).then((script)=>script.render());

if (document.getElementById("map") !== null) (parcelRequire("3z9vz")).then((script)=>script.render());

if (document.querySelector(".umbraco-forms-form") !== null) (parcelRequire("hjs2Y")).then((script)=>script.render());

if (document.querySelector("[data-tabs]") !== null) (parcelRequire("5aW2j")).then((script)=>script.render());

if (document.querySelector(".modal") !== null) (parcelRequire("6RZeE")).then((script)=>script.render());

if (document.querySelector(".in-page-links") != null) (parcelRequire("c60dm")).then((script)=>script.render());

if (document.querySelector(".loading-button, .onunload-loading-button") != null) (parcelRequire("2BQvH")).then((script)=>script.render());

if (document.querySelector(".faq-predictive-search") !== null) (parcelRequire("bdlUV")).then((script)=>script.render());

if (document.getElementById("chatTemplate") !== null) {
    const localOrIpAddress = new RegExp(/localhost|[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}|::1|\.local|^$/gi);
    const isLocalOrIpAddress = localOrIpAddress.test(window.location.hostname);
    if (window.location.hostname !== "" && !isLocalOrIpAddress) (parcelRequire("cfVbp")).then((script)=>{
        script.render();
    // script.open();
    });
}
//Accordion
// Fetch all the details element.
const $22c2c738ed8173e0$var$details = document.querySelectorAll("details");
// Add the onclick listeners.
$22c2c738ed8173e0$var$details.forEach((detail)=>{
    detail.addEventListener("toggle", ()=>{
        if (detail.open) setTargetDetail(detail);
    });
});
// Close all the details that are not targetDetail.
// This functionality is to make accordion to open only 1 accordion per click
/*function setTargetDetail(targetDetail) {
  details.forEach((detail) => {
    if (detail !== targetDetail) {
      detail.open = false;
    }
  });
} */ if (window.autoCompleteConfig) $("#query").autocomplete({
    source: window.autoCompleteConfig.source,
    minLength: 3,
    delay: 300,
    autoFocus: window.autoCompleteConfig.autoFocus,
    select: function(event, ui) {
        event.preventDefault();
        this.value = ui.item.label;
        window.location = ui.item.value;
    },
    focus: function(event, ui) {
        event.preventDefault();
    }
});
// Adds .row-content to social-share div if previous element has it
const $22c2c738ed8173e0$var$socialShareElems = document.querySelectorAll(".social-share-section");
if ($22c2c738ed8173e0$var$socialShareElems) $22c2c738ed8173e0$var$socialShareElems.forEach((elem)=>{
    const hasRowContentClass = elem.previousElementSibling?.classList?.contains("row-content");
    if (hasRowContentClass) elem.classList.add("row-content");
});
// Header carousel
const $22c2c738ed8173e0$var$swipers = document.querySelectorAll(".swiper");
if ($22c2c738ed8173e0$var$swipers) $22c2c738ed8173e0$var$swipers.forEach((elem)=>{
    const autoSlideTime = parseInt(elem.dataset.autoSlideTime) * 1000;
    const enableAutoPlay = autoSlideTime > 0;
    const swiper = new Swiper(elem, {
        loop: enableAutoPlay,
        autoplay: enableAutoPlay ? {
            delay: autoSlideTime,
            disableOnInteraction: false
        } : false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'custom',
            renderCustom: function(swiper, current, total) {
                var currentSlide = swiper.slides[current - 1];
                var isFullWidth = currentSlide.classList.contains("js-full-image");
                var html = `<div class="swiper-pagination-wrapper ${isFullWidth ? 'with-bg' : ''}">`;
                for(var i = 1; i <= total; i++)html += `<span class="swiper-pagination-bullet ${i == current ? 'swiper-pagination-bullet-active' : ''}" tabindex="0" role="button" aria-label="Go to slide ${i}" aria-current="${i == current ? "true" : "false"}"></span>`;
                html += '</div>';
                return html;
            }
        }
    });
});
// Footer accordion
const $22c2c738ed8173e0$var$footerNavAccordion = document.querySelectorAll("footer .mobile-accordion");
if ($22c2c738ed8173e0$var$footerNavAccordion) $22c2c738ed8173e0$var$footerNavAccordion.forEach((accordion)=>{
    accordion.querySelectorAll(".accordion-heading")?.forEach((heading)=>{
        const parent = heading.parentElement;
        heading.addEventListener("click", function() {
            if (heading.parentElement?.classList.contains("open")) parent?.classList.remove("open");
            else parent?.classList.add("open");
        });
    });
});
//quick Exit Button
var $22c2c738ed8173e0$var$quickExitButton = document.getElementById("quick-exit-button-wrapper");
if ($22c2c738ed8173e0$var$quickExitButton !== null) $22c2c738ed8173e0$var$quickExitButton.onclick = ()=>window.location.replace('https://google.com');
//sticky Banner Module  
$(function() {
    var banner = $(".sticky-bar");
    banner.hide();
    $(window).scroll(function() {
        if ($(window).scrollTop() >= 500) banner.fadeIn();
        else banner.hide();
    });
});

})();
//# sourceMappingURL=main.js.map
